var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tip",style:(_vm.style)},_vm._l((_vm.shuffledTips),function(tip,index){return _c('div',{key:("tip-" + index),ref:("tip-" + index),refInFor:true,class:{
			 active: _vm.i === index,
			 before: _vm.i < index || _vm.i === (_vm.tips.length - 1 && _vm.i !== index)
		 }},[_c('strong',{domProps:{"textContent":_vm._s(tip.title)}}),_c('div',{staticClass:"description",domProps:{"textContent":_vm._s(tip.tip)}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }